<template>
  <div class="w-full">
    <div class="relative border-1 rounded-2xl min-w-full min-h-[60vh] 2xl:min-h-[80vh] flex flex-col gap-2 px-2 pt-4 pb-5 border-gray-300">
      <!-- <div class="desktop:w-1/5 laptop:w-2/5 mx-auto absolute -top-6 right-4">
        <searchInput
          :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] px-3 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'"
          :buttonclass="'absolute top-1.5 right-1 w-7 h-7'" :img-src="require('@/assets/images/search-icon.png')" />
      </div> -->
      <!-- <div class="mx-auto absolute -top-5 right-4">
        
        <entities :modelValue="limit" @update:modelValue="onLimitChange" globalEntitiesClass="'tablet:w-[45%]'" />
        <createQoute />
      </div> -->
      <div
        class="mobile:w-[90%] mobile:right-0 mobile:left-0 laptop:w-4/5 desktop:w-3/5 largeDesktop:w-3/6 mx-auto flex tablet:justify-end  items-center gap-2 absolute -top-6 tablet:right-6 tablet:left-auto">
        <entities :modelValue="limit" @update:modelValue="onLimitChange" globalEntitiesClass="'tablet:w-[45%]'" />
        <searchInput :globalSearchClass="'mobile:w-full tablet:!w-[55%]'"
          :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'"
          :buttonclass="'absolute top-1.5 right-1 w-7 h-7'" :img-src="require('@/assets/images/search-icon.png')"
          :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
          v-model="search" @input="onSearch" :onClear="onClearSearch" :readonly="loading" :clearable="true" />
      </div>
      <div class="mt-2">
        <commisionAmountTable :tableHeaders="tableHeaders" :tableData="tableItems" :sortClicked="sortClicked" />
      </div>
    </div>
    <!-- <div class="flex justify-center relative -top-5">
      <customPagination />
    </div> -->
    <div v-if="tableItems && tableItems.length > 0"
      class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
      <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
        :totalItems="totalItems" />
      <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import entities from "../../components/showEntities/entities.vue";
import searchInput from '../../components/partialComponent/customInput.vue';
import commisionAmountTable from '../../components/protectionPlansCards/commisionAmountTable.vue';
// import createQoute from "../../components/createQuote/createQuote.vue";
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";

export default {
  components: {
    entities,
    searchInput,
    commisionAmountTable,
    // createQoute,
    customPagination,
    paginationEntries
  },
  data() {
    return {
      limit: 25,
      search: "",
      page: 1,
      total_pages: 0,
      totalItems: 0,
      debounceTimer: null,
      loading: false,
      tableHeaders: [],
      tableItems: [],
      selectedSort: {
        "column": "id",
        "direction": "DESC"
      },
    }
  },
  computed: {
    ...mapGetters([
      "commissionAmountListing",
    ]),
  },
  watch: {
    commissionAmountListing: function (data) {
      this.loading = false
      // this.list = this.commissionAmountListing.body
      // this.tableItems = []
      this.tableItems = this.commissionAmountListing.body
      this.total_pages = this.commissionAmountListing.paging.total_pages
      this.totalItems = this.commissionAmountListing.paging.total_records
    },
  },
  mounted() {
    this.setTableHeaders();
    this.loading = true
    this.getcommissionAmountListing({
      "search": this.search,
      "limit": this.limit,
      "page": this.page,
    });
  },
  methods: {
    ...mapActions([
      "getcommissionAmountListing",
    ]),
    updatePage(page) {
      if (page == this.page) return
      this.page = page
      this.loading = true
      this.getcommissionAmountListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page
      });
    },
    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.loading = true
          this.getcommissionAmountListing({
            "search": this.search,
            "limit": this.limit,
            "page": this.page
          });
        }
      }, 1000); // 1200ms delay
    },
    onClearSearch() {
      clearTimeout(this.debounceTimer);
      this.page = 1
      this.search = ''
      this.loading = true
      this.getcommissionAmountListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page
      });

    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.loading = true;
      this.getcommissionAmountListing({
        search: this.search,
        limit: this.limit,
        page: this.page,
      });
    },
    setTableHeaders() {
      this.tableHeaders = [
        this.getTableHeaderObject("ID", "id", "id", "", "1"),
        this.getTableHeaderObject("SRO Number", "sro_number", "sro_number", "", "1"),
        this.getTableHeaderObject("Consumer", "consumer_info", "consumer_info", "", "1"),
        this.getTableHeaderObject("Plan Name", "plan_name", "plan_name", "", "1"),
        this.getTableHeaderObject("Create Date", "create_date", "create_date", "", "1"),
        this.getTableHeaderObject("Process Date", "process_date", "process_date", "", "1"),
        this.getTableHeaderObject("Amount", "total_amount", "total_amount", "", "1"),
        this.getTableHeaderObject("Status", "status_slug", "status_slug", "", "1"),
      ]
      this.setSort()
    },
    getTableHeaderObject(title, data_value, sort_column, sort_direction, sort_applicable, isHeaderToolTipShow = 0, tooltip_text = '') {
      return {
        title: title,
        data_value: data_value,
        sort_column: sort_column,
        sort_direction: sort_direction,
        sort_applicable: sort_applicable,
        isHeaderToolTipShow: isHeaderToolTipShow,
        tooltip_text: tooltip_text
      }
    },
    setSort() {
      this.tableHeaders.map(obj => {
        if (obj.sort_column == this.selectedSort.column) {
          obj.sort_direction = this.selectedSort.direction;
        } else {
          obj.sort_direction = "";
        }
      });
    },
    sortClicked(item) {
      if (item.sort_applicable == '1') {
        this.page = 1
        if (item.sort_column == this.selectedSort.column) {
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        } else {
          this.tableHeaders.map(obj => {
            obj.sort_direction = "";
          });
          this.selectedSort.column = item.sort_column
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        }
        this.getcommissionAmountListing({
          search: this.search,
          limit: this.limit,
          page: this.page,
          sort: this.selectedSort,
        })
      }
    },
  },
};
</script>